module.exports = __webpack_public_path__ + "img/mobile-btn-ios.8be955f0.webp";